export const leadAdapter =
    (obj) => ({
      ...obj,
      multiple_responsible: obj.multiple_responsible?.map(x => x.id) || []
    })

